module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "sec_number",
    attrs: {
      "id": "ch1"
    }
  }, [_vm._v("Chapter 1")]), _vm._v(" "), _c('h2', {
    staticClass: "sec_chapter"
  }, [_vm._v("The Road to Destiny")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap2line"
  }, [_vm._v("E")]), _vm._v("mmanuel, Second Marquis de Grouchy, was touching fifty in 1815. He walked with a limp the result of a severe leg wound he had received at Craonne a year earlier, a wound which had taken a long time to heal. He had served in the French army for some thirty-six years, originally enlisting in the Corps Royal d’Artillerie in 1779. Despite his family background, Emmanuel—perhaps thanks to his intellectual mother, Gilberte Freteau de Peny, and his sister, the early feminist, Sophie de Condorcet—was an ardent supporter of the youthful French Republic, and fought in many of the major battles of the republic and Napoléon’s empire. He was an able divisional and corps commander, but upon Napoléon’s resumption of the French throne in spring 1815, he found himself promoted to the dignity of marshal of France. During this troubled and turbulent time, could he rise to the challenge set by Napoléon?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The story of Grouchy’s controversial mission of 17 June 1815 has, ever since it happened, become dominated by hindsight and all kinds of personal and political interests from eyewitnesses who served under him in 1815. He had been accused of being one of the determining causes, if not the cause, of the defeat of the emperor at Waterloo. As a result of this, it is very hard to get down to the nub of the issues at hand due to complex self-interest of the men from 1815, and from later historians. What I aim to do with this book is to judge Grouchy and his mission, as far as possible, from what was known on those fateful June days and, where needed, to expose aspects of those events as either truth or lies. This is only possible with a thorough examination of all the original documents from 1815 that can be found by the author, a task not undertaken since at least 1840 by Grouchy himself.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the words of Gregor Dallas, Napoléon’s position in spring 1815 was built on ‘wobbly foundations.’ There was the very real prospect of civil war. Napoléon no longer possessed the means to re-impose a dictatorship, and no single political faction was dominant; he presided over political and domestic chaos of his own making. In 1815, Napoléon did not represent national will, with the support from, it is estimated, 3 per cent of the nation. Revolt in the spring of 1815 was not just limited to France. In London, riots against the government and its punitive corn laws came to an end in mid-March. Nationalist riots broke out in the former French Confederation of the Rhine states against the Prussians. Europe, in spring 1815, was a tinderbox of discontent, into which came Napoléon.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Yet despite the worrying developments on the home front, Napoléon was determined to take the inevitable war to the Allies before they could attack France.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On the 3 June, Napoléon informed Marshals Soult and Davout that Marshal Grouchy had been named commander-in-chief of the cavalry of the Armée du Nord. Grouchy joined the Imperial Headquarters at Laon on 5 June, and began to work with Soult on establishing the movement orders for the forthcoming campaign.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Imperial Guard left Paris on 8 June 1815. Napoléon left Paris on 12 June for Soissons to join headquarters. On the Belgian border were the two Allied armies; a force of 116,000 Prussians and Saxons, led by the Prussian Field Marshal Gebhard Leberecht von Blücher, was based at Namur, and a force of 93,000 British, Dutch, and German troops based at Brussels, commanded by the Duke of Wellington. Leading elements of the Allied armies were at Charleroi and Gilly on the evening of 14 June 1815.")]), _vm._v(" "), _c('h3', {
    staticClass: "sub_section1"
  }, [_vm._v("NOTES:")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "id": "ch01-fn-1"
    }
  }, [_vm._v("1")])]), _vm._v(" Gregor Dallas, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("1815: The Roads to Waterloo")]), _vm._v(", Pimlico, London, 1996, p. 313.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "id": "ch01-fn-2"
    }
  }, [_vm._v("2")])]), _vm._v(" Dallas, p. 315.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "id": "ch01-fn-3"
    }
  }, [_vm._v("3")])]), _vm._v(" Dallas, p. 323.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "id": "ch01-fn-4"
    }
  }, [_vm._v("4")])]), _vm._v(" The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Morning Chronicle")]), _vm._v(", 18 March 1815.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0854a476","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_Chapter_1.vue
// module id = 75
// module chunks = 0